import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerformanceDetail from './components/performance-detail';
import TrendAnalysis from './components/trend-analysis';
import iconEmptyMyPerformance from './empty-my-performance.svg';
class Performance extends Component {
  state = {
    hasFinishedLoadingData: true,
  }

  componentDidMount() {
    // this.initializeComponent(this.props.year);
  }

  componentDidUpdate(prevProps) {
    // console.log(this.props);
    // const { props } = this;
    // if (props.ajaxDataLoadStatuses.ordersxes === 'PENDING' &&
    //     this.props.ajaxDataLoadStatuses.ordersxes === '') {
    //   this.setState({
    //     hasFinishedLoadingData: true,
    //   });
    // }
    // if (this.props.year !== prevProps.year) {
    //   this.initializeComponent(this.props.year);
    // }

    // Only update state if specific props changed to prevent infinite loop
    // prevProps !== this.props is always true and causes infinite updates
    if (this.props.year !== prevProps.year ||
        this.props.ordersxes !== prevProps.ordersxes) {
      this.setState({
        hasFinishedLoadingData: true,
      });
    }
  }

  // initializeComponent = (year) => {
  //   const { props } = this;
  //   const user = props.user;
  //   this.setState({
  //     hasFinishedLoadingData: false,
  //   }, () => props.dataLoad({
  //     key: 'ordersxes',
  //     url: `${user._links.orders_xes.href}${year ? `?year=${year}` : ''}`,
  //     auth: user.auth,
  //   }));
  // }

  render() {
    const { props, state } = this;
    const orders = props.ordersxes;
    const isLoading = !state.hasFinishedLoadingData;
    const isEmpty = Object.keys(orders).length === 0;
    const enabledQuarters = props.currentYear !== props.year;

    if (isLoading) {
      // return (
      //   <EmptyState
      //     mainCopy=""
      //     className={'lr-credit-for-all-customers'}
      //     isLoading={isLoading}
      //     user={props.user}
      //   />
      // );
    }
    return (
      <div className="lr-targets-container">
        <div className="lr-performance-year">{moment(props.year, 'YYYY')
      .format('YYYY')}</div>
        {
          isEmpty ?
            <div className="lr-loyalty__schemes">
              <div className="lr-loyalty-empty">
                <div className="lr-loyalty-empty-Inner">
                  <img className="lr-loyalty-empty__icon image-center" src={iconEmptyMyPerformance} alt="icon" />
                  <p>You haven't placed any orders yet.</p>
                  <p>When you confirm receipt of your first order it will appear here</p>
                </div>
              </div>
            </div>
          :
            <TrendAnalysis
              orders={orders}
              year={props.year}
              currentYear={props.currentYear}
              enabledQuarters={enabledQuarters}
              user={props.user}
            />
        }
        <PerformanceDetail
          orders={orders}
          user={props.user}
          fetchFilterData={props.fetchFilterData}
          enabledQuarters={enabledQuarters}
        />
      </div>
    );
  }
}

Performance.propTypes = {
  // ajaxDataLoadStatuses: PropTypes.shape({
  //   ordersxes: PropTypes.string.isRequired,
  // }).isRequired,
  year: PropTypes.node,
};

Performance.defaultProps = {
  year: undefined,
};

export default Performance;
